<template>
  <AssetLibraryDialog
    title="Select Videos"
    :initialSelectedAssets="initialSelectedFillerSlides"
    :getAssetsFn="getFillerSlideAssets"
    :maxSelections="maxSelections"
    @close="$emit('close')"
    @select="assets => $emit('select-filler-slides', assets)"
  >
    <template #upload-button="{ success, init, failure, close }">
      <UploadFillerSlide @success="success" @init="init" @failure="failure" @close="close">
        <StudioButton trackingId="upload-filler-slide-button">+ Upload Filler Slide</StudioButton>
      </UploadFillerSlide>
    </template>
    <template #assets-list-item="{ asset, isSelected, handleSelectAsset, handleDeleteSuccess, handleRenameSuccess }">
      <FillerSlideLibraryListItem
        :fillerSlideAsset="asset"
        :isSelected="isSelected"
        allowSelection
        :visibleActions="{
          openPreview: true,
          download: true,
          rename: true,
          delete: true
        }"
        @select-filler-slide="handleSelectAsset"
        @delete-success="handleDeleteSuccess"
        @rename-success="handleRenameSuccess"
      />
    </template>
  </AssetLibraryDialog>
</template>

<script>
import { defineComponent } from 'vue';

import FillerSlideLibraryListItem from './FillerSlideLibraryListItem.vue';
import { getFillerSlideAssets } from './fillerSlideLibraryService';
import UploadFillerSlide from './UploadFillerSlide.vue';

import AssetLibraryDialog from '@/studio/studioLibrary/AssetLibraryDialog.vue';
import StudioButton from '@/studioComponents/StudioButton.vue';

export default defineComponent({
  name: 'FillerSlideLibraryDialog',
  components: {
    AssetLibraryDialog,
    StudioButton,
    UploadFillerSlide,
    FillerSlideLibraryListItem
  },
  props: {
    initialSelectedFillerSlides: {
      type: Array,
      default: () => []
    },
    maxSelections: {
      type: Number,
      default: Infinity
    }
  },
  methods: {
    getFillerSlideAssets
  }
});
</script>
